import { createStoreChunk } from '@core/store'

export type TAddToCollectionAudio = {
    id: string
    title: string
    authorUsername: string
}

type TAddToCollectionState = {
    audio: TAddToCollectionAudio | null
}

export const addToCollectionStore = createStoreChunk<TAddToCollectionState>('addToCollection')({
    initialState: { audio: null },
})
